import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import {seo, theme} from "./portfolio";
import {applySeo} from "./utils/applySeo";
import {applyTheme} from "./utils/applyTheme";

// Push the CMS-managed theme + SEO values into the document before first paint.
applyTheme(theme);
applySeo(seo);

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
